import React from "react";
import { Navigate } from "react-router-dom";

const StkSriIssued = React.lazy(
  () => import("../../../../../components/retentions/components/panel/page"),
);
const StkSriRetention = React.lazy(
  () => import("../../../../../components/retentions/components/received/page"),
);
const StkSriRetentionEmitted = React.lazy(
  () => import("../../../../../components/retentions/components/emitted-external/page"),
);
const StkSriRetentionCodes = React.lazy(
  () => import("../../../../../components/retentions/components/codes/page"),
);
const StkAtsPanel = React.lazy(
  () => import("../../../../../components/stk-sri/components/ats-panel/page"),
);
const StkSriVoided = React.lazy(
  () => import("../../../../../components/stk-sri/components/voided/page"),
);
const SriSyncJobPanel = React.lazy(
  () => import("../../../../../components/sri-sync-job/components/list/page"),
);
const SriCreateInvoice = React.lazy(
  () => import("../../../../../components/stk-sale/components/invoice/page"),
);

export const retencionesRoutes = [
  {
    path: "add",
    element: <SriCreateInvoice />,
  },
  {
    path: "issued",
    element: <StkSriIssued />,
  },
   {
    path: "agent",
    element: <SriSyncJobPanel />,
  },
  {
    path: "received",
    element: <StkSriRetention />,
  },
  {
    path: "emitted",
    element: <StkSriRetentionEmitted />,
  },
  {
    path: "voided",
    element: <StkSriVoided kind="retentions" />,
  },
  {
    path: "codes",
    element: <StkSriRetentionCodes />,
  },
  {
    path: "",
    element: <Navigate replace to="/sri/retentions/issued" />,
  },
];
